import React from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from 'antd';
import { SessionFormItem } from '@components/Clinicians/Session/Components/SessionFormItem';
import { type ApptActionCodes } from 'vl-common/src/schemas/getMetaAppointments';
import { useSessionAction } from '@hooks/useSessionAction';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { useSessionFormState } from '@hooks/useSessionFormState';

export const ReferSelfFormItem = ({
  onChange = () => {},
  actionCode
}: {
  onChange: (value: 0 | 1) => void;
  actionCode: ApptActionCodes;
}) => {
  const { t } = useTranslation('common');
  const { REFER_SELF_KEY } = useSessionAction(actionCode);

  const {
    appointment: { appointment_completed: isCompleted, read_only: readonly }
  } = useSessionAppointment();
  const [referSelf] = useSessionFormState(REFER_SELF_KEY);
  return (
    <SessionFormItem
      label={t('Are you referring the patient to another clinician?')}
      name={REFER_SELF_KEY}
      required
      isGroupField
    >
      <Radio.Group
        disabled={isCompleted || readonly}
        value={referSelf}
        defaultValue={referSelf}
        onChange={({ target }) => onChange(target.value)}
      >
        <Radio value={0}>{t('Yes')}</Radio>
        <Radio value={1}>{t('No')}</Radio>
      </Radio.Group>
    </SessionFormItem>
  );
};
